import SEO from "../components/SEO";
import Reveal from "../components/Reveal";
import IntegrationsGrid from "../sections/IntegrationsGrid";
import FinalCTA from "../sections/FinalCTA";

export default function Integrations() {
  return (
    <>
      <SEO
        title="Integrations"
        description="ClientDesk VA connects to Google Calendar, Microsoft Outlook, Google Meet, Microsoft Teams, Stripe and Apple in-app purchases."
        path="/integrations"
      />
      <section className="pt-20 pb-8 bg-[#FAF7F2]">
        <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
          <Reveal>
            <div className="text-[13px] font-semibold uppercase tracking-[0.14em] text-[#E8712C] mb-3">
              Integrations
            </div>
            <h1 className="font-display font-extrabold text-[36px] sm:text-[52px] leading-[1.05] tracking-[-0.03em] text-[#1A2A3A] mb-5">
              Plays nicely with the calendar you already use.
            </h1>
            <p className="text-[17px] text-[#57534E] max-w-2xl mx-auto leading-relaxed">
              We only list what you can actually connect today. More is on the
              way — you'll hear about it when it ships, not before.
            </p>
          </Reveal>
        </div>
      </section>
      <IntegrationsGrid />
      <FinalCTA />
    </>
  );
}
